import angular from 'angular';

import abuUploadSummaryTableComponent from './abu-upload-summary-table-component';
import shared from '../shared/shared';

const abuUploadSummaryTable = angular.module('abuUploadSummaryTable', [shared]);
abuUploadSummaryTable.component('abuUploadSummaryTable', abuUploadSummaryTableComponent);

export default abuUploadSummaryTable.name;
